'use strict';

/**
 * Controller definition for the import dialog
 *
 * @category   Module
 * @module     import
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Backbone = require('backbone');
var ColidoController = require('base/Colido.Controller');
var ImportLayout = require('./views/layout/import');
var ImportsLayout = require('./views/layout/imports');
var ImportObjectListLayout = require('./views/layout/import-object-list');

var Controller = ColidoController.extend({
    routes: {
        'catalogs/:catalogId/imports': 'actionList',
        'catalogs/:catalogId/imports(/warnings)/:id(/filter/*filter)(/sort/:sort)(/show/:id)': 'actionImportDetail',
        'catalogs/:catalogId/import': 'actionImport',
    },

    initialize: function (options) {
        this.module = this.getOption('module');
    },

    actionImport: function(catalogId) {
        this.onDataReady(App.CollectionModule.catalogs, function() {
            var catalog = App.CollectionModule.catalogs.get(catalogId);

            if (!catalog) {
                console.log('@todo: forward to catalog 404');

                return;
            }

            App.requireData([
                catalog.storages,
                App.radio().request('currencies:collection'),
            ], function() {
                var region = App.rootView.mainRegion.currentView.extraContentRegion;
                var layout = new ImportLayout({collection: catalog.imports});

                region.show(layout);
            });
        });
    },

    actionImportDetail: function(catalogId, importId, filter, sort, id) {
        this.onDataReady(App.CollectionModule.catalogs, function() {
            var catalog = App.CollectionModule.catalogs.get(catalogId);

            if (!catalog) {
                console.log('@todo: forward to catalog 404');

                return;
            }

            App.requireData([
                catalog.objects,
                catalog.sets,
                catalog.storages,
                catalog.imports,
            ], function() {
                var isWarning = Backbone.history.fragment.search(/warnings/i) !== -1;
                var model = catalog.imports.get(importId);

                //remove from catalog.importsCount for unseen import lists
                model.save({
                    seen: true,
                }, {
                    patch: true,
                });

                var params = {
                    filter: filter,
                    sort: sort,
                    id: id,
                    importModel: null,
                    importWarningsModel: null,
                };

                params[isWarning ? 'importWarningsModel' : 'importModel'] = model;

                App.CollectionModule.controller.objectsList(catalog.objects, ImportObjectListLayout, params);
            });
        });
    },

    actionList: function(catalogId){
        this.onDataReady(App.CollectionModule.catalogs, function() {
            var catalog = App.CollectionModule.catalogs.get(catalogId);

            if (!catalog) {
                console.log('@todo: forward to catalog 404');

                return;
            }

            App.requireData([
                catalog.imports,
                App.radio().request('currencies:collection'),
                App.BaseModule.unitsCollection,
                //'base:collection-input-fields', //@todo
            ], function() {
                var region = App.rootView.mainRegion.currentView.contentRegion;
                var layout = new ImportsLayout({
                    model: catalog,
                    collection: catalog.imports,
                });
                region.show(layout);
            });
        });
    },

});

module.exports = Controller;